import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as _ from 'lodash';
import {switchMap, take} from 'rxjs/internal/operators';
import {Action, select, Store} from '@ngrx/store';
import * as fromShared from '../reducers';
import * as fromRoot from '../reducers';
import {catchError, map, withLatestFrom, filter, delayWhen} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {
  clientConfigurationActionTypes,
  LoadClientConfigurationAction,
  LoadClientConfigurationFailAction,
  LoadClientConfigurationSuccessAction
} from '../actions/client-configuration';
import {SendBackResult} from '../models/send-back-result';
import {BaseEffect} from './base.effect';
import {L10nTranslationService} from 'angular-l10n';
import {ClientConfigurationService} from '../services/client-configuration.service';
import {AssignPlayerAction} from '../../order/actions/assign-player';

@Injectable()
export class ClientConfigurationEffect extends BaseEffect {
  // private client$ = this.store.pipe(select(fromRoot.selectors.getCurrentClient)).pipe(filter(client => !_.isEmpty(client)));

  load$ = createEffect(() => { return this.actions$.pipe(
    ofType(clientConfigurationActionTypes.LOAD),
    debug('Load ClientConfiguration action received.'),
    map((action: LoadClientConfigurationAction) => action.payload),
    // @ts-ignore
    switchMap((payloadData) => this.clientConfigurationService.getList(payloadData)
      // tslint:disable-next-line:no-any
      .pipe(map((payload: SendBackResult<ArrayResponse<any>>) =>
          new LoadClientConfigurationSuccessAction(payload.data.array))))
  )});


  loadFail$ = createEffect(() => {
    return this.actions$.pipe(ofType(clientConfigurationActionTypes.LOAD_FAIL),
    debug('Load ClientConfigurationEffect fail action received.'),
    map((err: LoadClientConfigurationFailAction ) =>
      error(this.translation.translate('CULTURES_LOAD_ERROR') + err.payload,
        this.translation.translate('TOAST_ERROR_TITLE'))
    ))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService ,
              private clientConfigurationService: ClientConfigurationService,
              private store: Store<fromRoot.AppState>,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadClientConfigurationFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadClientConfigurationFailAction(response['error'].message);
  }
}
